import { render, staticRenderFns } from "./PremiumModal.vue?vue&type=template&id=7db2b51e"
import script from "./PremiumModal.vue?vue&type=script&lang=js"
export * from "./PremiumModal.vue?vue&type=script&lang=js"
import style0 from "./PremiumModal.vue?vue&type=style&index=0&id=7db2b51e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports